import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

const Wrong = ({ answerAgain, mobile, text, instruction }) => {
    return (
        <Fragment>
            <div className="question question--wrong">
                <div className="question__header">
                    <span className="icon icon-wrong"></span>
                    <FormattedMessage id="wrong.title" defaultMessage="Watch out!">
                        {
                            label => (
                                <p className="title">{label}</p>
                            )
                        }
                    </FormattedMessage>
                </div>
                <div className="question__content">
                    <p className="lead">{text}</p>
                    <p>{instruction}</p>
                </div>
            </div>
            {
                !mobile &&
                <div className="question__footer">
                    <FormattedMessage id="wrong.button.again" defaultMessage="Answer again">
                        {
                            label => (
                                <button onClick={answerAgain} className="btn btn--primary" type="button"><span className="label">{label}</span></button>
                            )
                        }
                    </FormattedMessage>
                </div>
            }
        </Fragment>
    )
}

Wrong.propTypes = {

}

export default Wrong
